const FooterColor = "#042F40";
const NavbarColor = "#042F40";
const InfoColor = "#167362";
const AccentOne = "#F2A20C";
const AccentTwo = "#A7D175";

class Colors {
  static get footerColor() {
    return FooterColor;
  }

  static get navbarColor() {
    return NavbarColor;
  }

  static get infoColor() {
    return InfoColor;
  }

  static get accentOneColor() {
    return AccentOne;
  }

  static get accentTwoColor() {
    return AccentTwo;
  }
}

export default Colors;
